import React, { useContext } from 'react';
import './TopAlarmers.css';
import ModuleLoadingStatus from '../ModuleLoadingStatus/ModuleLoadingStatus';
import { CardTopAlarmsContext } from '../../contexts/CardTopAlarmsContext';
import logComponent from '../../common/logComponent';

export default function TopAlarmersLoadingStatus({ reloadAction }) {
  const cardTopAlarmsContext = useContext(CardTopAlarmsContext);
  const { topAlarmsLoading, topAlarmsError } = cardTopAlarmsContext;

  if (logComponent('TopAlarmersLoadingStatus')) { console.debug('TopAlarmersLoadingStatus rendered'); }


  return (
    <ModuleLoadingStatus isLoading={topAlarmsLoading} isError={topAlarmsError} reloadAction={reloadAction} />
  );
}